<div class="external-links-container">
  <ul class="links-list">
    <li class="link">
      <a *ngIf="!isLoadingLinks && learnAboutIoUrl"
        class="external-link" [routerLink]="['/learn-about-io']">Learn About Immunotherapy</a>
      <span *ngIf="isLoadingLinks" class="loading link"></span>
    </li>
    <li class="link">
      <a *ngIf="!isLoadingLinks && livingWithCancerUrl"
        class="external-link" [attr.href]="livingWithCancerUrl" target="_blank">Living with Cancer</a>
      <span *ngIf="isLoadingLinks" class="loading link"></span>
    </li>
  </ul>
</div>
